import React from 'react'
import './Sport_card.css'
import { useNavigate } from 'react-router-dom'

const Sport_card = (props) => {

   const navigate = useNavigate()

  return (
    <>
        <section className='Sport_card_sec' onClick={() => {navigate("/sports-programs")}}>
            <div className='icondiv'>
                <img className='sporticon' src={props.sportIcon} alt="sport-icon" />
            </div>
            <h6 className='name'>{props.name}</h6>
            <p className='discription'>{props.discription}</p>
        </section>
    </>
  )
}

export default Sport_card